class Loader {
    constructor(domElement) {
        if (!domElement) {
            domElement = document.body;
        }

        this.regularDurationTimeoutHandle = null;
        this.domElement = domElement;

        this.createElements();
    }

    createElements() {
        this.loaderDomElement = document.createElement('div');
        this.loaderDomElement.className = 'loader';

        this.loaderImgDomElement = document.createElement('img');
        this.loaderImgDomElement.className = 'loader-image';
        this.loaderImgDomElement.src = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiByZ2JhKDAsIDAsIDAsIDApIG5vbmUgcmVwZWF0IHNjcm9sbCAwJSAwJTsgZGlzcGxheTogYmxvY2s7IHNoYXBlLXJlbmRlcmluZzogYXV0bzsiIHdpZHRoPSIyMDBweCIgaGVpZ2h0PSIyMDBweCINCiAgICAgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIj4NCiAgICA8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMTAiIHI9IjM1IiBzdHJva2UtZGFzaGFycmF5PSIxNjQuOTMzNjE0MzEzNDY0MTUgNTYuOTc3ODcxNDM3ODIxMzgiPg0KICAgICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMXMiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiIGtleVRpbWVzPSIwOzEiPjwvYW5pbWF0ZVRyYW5zZm9ybT4NCiAgICA8L2NpcmNsZT4NCiAgICA8IS0tIFtsZGlvXSBnZW5lcmF0ZWQgYnkgaHR0cHM6Ly9sb2FkaW5nLmlvLyAtLT4NCjwvc3ZnPg==';

        this.loaderStatusDomElement = document.createElement('div');
        this.loaderStatusDomElement.className = 'loader-status';
        this.loaderStatusDomElement.innerHTML = 'Loading...';

        this.loaderDomElement.appendChild(this.loaderImgDomElement);
        this.loaderDomElement.appendChild(this.loaderStatusDomElement);
    }

    onRegularDurationTimeout() {
        this.setStatus('This is taking longer than expected...');
        this.regularDurationTimeoutHandle = null;
    }

    setStatus(status) {
        this.loaderStatusDomElement.innerHTML = '';

        const textElement = document.createTextNode(status);
        this.loaderStatusDomElement.appendChild(textElement);
    }

    show(regularTime = 0) {
        this.domElement.appendChild(this.loaderDomElement);

        if (regularTime > 0) {
            this.regularDurationTimeoutHandle = setTimeout(this.onRegularDurationTimeout.bind(this), regularTime);
        }
    }

    close() {
        if (!!this.regularDurationTimeoutHandle) {
            clearTimeout(this.regularDurationTimeoutHandle);
            this.regularDurationTimeoutHandle = null;
        }

        this.domElement.removeChild(this.loaderDomElement);
    }
}

export default Loader;
